const resources = {
    freeReturns: 'Retours gratuits',
    exclusions: 'voir les détails et les exceptions*.',
    allPurchases: 'on all purchases.*'
};

module.exports = function getResource(label) {
    return resources[label];
};
